"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOPPCardResponse = exports.IOPPPaymentMethodResponse = void 0;
var IOPPPaymentMethodResponse;
(function (IOPPPaymentMethodResponse) {
    let TypeEnum;
    (function (TypeEnum) {
        TypeEnum["CARD"] = "CARD";
    })(TypeEnum = IOPPPaymentMethodResponse.TypeEnum || (IOPPPaymentMethodResponse.TypeEnum = {}));
    let StateEnum;
    (function (StateEnum) {
        StateEnum["INITIALIZED"] = "INITIALIZED";
        StateEnum["IN_AUTHORIZATION"] = "IN_AUTHORIZATION";
        StateEnum["ACTIVE"] = "ACTIVE";
        StateEnum["INACTIVE"] = "INACTIVE";
        StateEnum["EXPIRED"] = "EXPIRED";
        StateEnum["DELETED"] = "DELETED";
    })(StateEnum = IOPPPaymentMethodResponse.StateEnum || (IOPPPaymentMethodResponse.StateEnum = {}));
    let PaymentOptionsEnum;
    (function (PaymentOptionsEnum) {
        PaymentOptionsEnum["FULLPAN"] = "FULL_PAN";
        PaymentOptionsEnum["NETWORKTOKEN"] = "NETWORK_TOKEN";
    })(PaymentOptionsEnum = IOPPPaymentMethodResponse.PaymentOptionsEnum || (IOPPPaymentMethodResponse.PaymentOptionsEnum = {}));
})(IOPPPaymentMethodResponse || (exports.IOPPPaymentMethodResponse = IOPPPaymentMethodResponse = {}));
var IOPPCardResponse;
(function (IOPPCardResponse) {
    let CardSchemeEnum;
    (function (CardSchemeEnum) {
        CardSchemeEnum["VISA"] = "VISA";
        CardSchemeEnum["MASTERCARD"] = "MASTERCARD";
        CardSchemeEnum["AMERICANEXPRESS"] = "AMERICAN_EXPRESS";
        CardSchemeEnum["DISCOVER"] = "DISCOVER";
        CardSchemeEnum["DINERSCLUB"] = "DINERS_CLUB";
        CardSchemeEnum["JCB"] = "JCB";
        CardSchemeEnum["UNIONPAY"] = "UNION_PAY";
        CardSchemeEnum["UNKNOWN"] = "UNKNOWN";
    })(CardSchemeEnum = IOPPCardResponse.CardSchemeEnum || (IOPPCardResponse.CardSchemeEnum = {}));
})(IOPPCardResponse || (exports.IOPPCardResponse = IOPPCardResponse = {}));
//# sourceMappingURL=types.js.map